/**
 * @author kuan
 */

export const ANALYSIS = {
  '0.5': {category:'editor_dub', action:'click_stop_0.5', label:'编辑器_智能配音_停顿0.5s'},
  '1': {category:'editor_dub', action:'click_stop_1', label:'编辑器_智能配音_停顿1s'},
  '2': {category:'editor_dub', action:'click_stop_2', label:'编辑器_智能配音_停顿2s'},
  'testPlay': {category:'editor_dub', action:'click_pre_listen', label:'编辑器_试听'},
  'generate': {category:'editor_dub', action:'click_confirm_mixdub', label:'编辑器_智能配音_合成语音'},
  'confirm': {category:'editor_dub', action:'click_confirm_dub', label:'编辑器_录音_确定'}
}

  export default {
    data () {
      return {
        ANALYSIS
      }
    }
  }



// WEBPACK FOOTER //
// ./src/components/mixins/analysis/generateVoice.js